import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { ToastService } from '../services/Toast.service';
import { TOAST_TYPE } from '../constants/Tpiq.constants';
import { ProjectionsHandoffService } from '../tpiq-services/projections-handoff.service';

/**
 * Post-login interstitial for users with Planning and Projections access.
 *
 * The backend resolves access. This component only renders the two choices.
 *
 * Visually mirrors the projections-side landing page at
 * taxplaniq-platform/frontend/src/app/features/landing/. SCSS uses hardcoded
 * hex values (legacy app lacks the projections design-token CSS variables).
 */
@Component({
  selector: 'app-choose-platform',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './choose-platform.component.html',
  styleUrl: './choose-platform.component.scss',
})
export class ChoosePlatformComponent {

  isRedirecting = false;

  constructor(
    private projectionsHandoffService: ProjectionsHandoffService,
    private router: Router,
    private toastService: ToastService,
  ) {}

  /** Tax Planning card — continue to the legacy dashboard. */
  goToTaxPlanning(): void {
    // If a Tax Projections handoff is in flight, ignore — the user is
    // already mid-redirect to projections; navigating to /tpiq/dashboard
    // here would race the cross-host redirect.
    if (this.isRedirecting) return;
    this.router.navigate(['/tpiq/dashboard']);
  }

  /** Tax Projections card — issue a one-time handoff token via legacy backend
   *  (HandoffOutController), then redirect to the projections frontend with
   *  the token in the URL. The projections /handoff component consumes it. */
  goToTaxProjections(): void {
    if (this.isRedirecting) return;
    this.isRedirecting = true;

    this.projectionsHandoffService.createRedirect().subscribe({
      next: (redirectUrl) => {
        window.location.assign(redirectUrl);
      },
      error: (error) => {
        this.isRedirecting = false;
        this.toastService.pop(
          TOAST_TYPE.error,
          error?.message || 'Tax Projections handoff failed',
        );
      }
    });
  }
}
